/* eslint-disable @typescript-eslint/no-explicit-any */
export const processCustomerGraphData = (salesAnalytics: any) => {
    const years = Object.keys(salesAnalytics);
    const months: string[] = [];
    const totalLeads: number[] = [];
    const totalLeadConversion: number[] = [];

    years.forEach((year) => {
        const monthsData = salesAnalytics[year];
        Object.keys(monthsData).forEach((month) => {
            months.push(`${month} ${year}`);
            totalLeads.push(monthsData[month].total_leads);
            totalLeadConversion.push(parseFloat(monthsData[month].total_lead_conversion));
        });
    });

    return { months, totalLeads, totalLeadConversion };
};
